var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkerAccomodation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 36,
  height: 44,
  viewBox: "0 0 36 44"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "146.4%",
  height: "136.1%",
  x: "-23.2%",
  y: "-15.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "M14 36q14-13.701 14-21.635C28 6.431 21.732 0 14 0S0 6.431 0 14.365Q0 22.299 14 36"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 3)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  fill: "#000",
  filter: "url(#a)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  fill: "#DE2E5F"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m18.373 10.081 5.786 3.543c.212.13.341.36.341.609v9.235c0 .394-.32.714-.714.714l-3.349-.001v-4.776h-4.875v4.776h-3.348a.714.714 0 0 1-.714-.713v-9.235c0-.249.13-.48.341-.609l5.786-3.543a.71.71 0 0 1 .746 0"
}))));
export default SvgMarkerAccomodation;